import { CoachingEntity } from './coaching-entity.model';
import { DateRestriction } from './date-restriction.model';
import { InteractionPurpose } from './interaction-purpose.model';
import { InteractionScoringEntity } from './interaction-scoring-entity.model';
import { InteractionType } from './interaction-type.model';
import { NoteEntity } from './note-entity.model';

export const InteractionEntityType = 'interaction';

export interface InteractionEntity
    extends CoachingEntity<NoteEntity | InteractionScoringEntity> {
    /** stored procedure inflates to an object */
    interactionTypes: InteractionType[];
    interactionPurposeEnabled: boolean;
    interactionPurpose: InteractionPurpose[];

    dateRestriction: DateRestriction;
}
